import { action } from 'mobx';
import { request } from 'utils/api';
import BaseStore from 'common/stores/BaseStore';
import { API_URL } from 'utils/env/client';

export default class ParkingStore extends BaseStore {
  @action
  getPage() {
    return request({
      method: 'GET',
      path: `/1/parking/page`,
    });
  }

  @action
  getTicketInfo(ticketId, isLicensePlate) {
    return request({
      method: 'GET',
      path: `/1/parking/ticket-info?ticketId=${ticketId}&isLicensePlate=${!!isLicensePlate}`,
    });
  }

  @action
  createPaymentIntent(ticketId, isLicensePlate) {
    return request({
      method: 'GET',
      path: `/1/parking/payment-intent?ticketId=${ticketId}&isLicensePlate=${!!isLicensePlate}`,
    });
  }

  @action
  getPaymentIntent(paymentIntentId) {
    return request({
      method: 'GET',
      path: `/1/parking/payment-intent?paymentIntentId=${paymentIntentId}`,
    });
  }

  @action
  getInfo(ticketId, isLicensePlate, pi) {
    return request({
      method: 'GET',
      path: `/1/parking/get-info?ticketId=${ticketId}&isLicensePlate=${!!isLicensePlate}${
        pi ? `&pi=${pi}` : ''
      }`,
    });
  }

  @action
  addPayment(ticketId, paymentIntentId, isLicensePlate, email) {
    return request({
      method: 'POST',
      path: `/1/parking/add-payment`,
      body: {
        ticketId,
        paymentIntentId,
        isLicensePlate,
        email,
      },
    });
  }

  @action
  addFreedomPayPayment(ticketId, freedomPayData, isLicensePlate, email) {
    return request({
      method: 'POST',
      path: `/1/parking/add-freedompay-payment`,
      body: {
        ticketId,
        freedomPayData,
        isLicensePlate,
        email,
      },
    });
  }

  @action
  async uploadReceipt(ticketId, isLicensePlate, file) {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('ticketId', ticketId);
    formData.append('isLicensePlate', isLicensePlate.toString());

    const response = await fetch(`${API_URL}/1/parking/validate-receipt`, {
      method: 'POST',
      body: formData,
    });

    return await response.json();
  }

  @action
  async validateReceiptUrl(ticketId, isLicensePlate, url) {
    const response = await fetch(`${API_URL}/1/parking/validate-receipt-url`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        ticketId,
        isLicensePlate: isLicensePlate.toString(),
        url,
      }),
    });

    return await response.json();
  }
}
